import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import Amplitude from '../../utils/amplitudeHelper'
import LoadIcon from '../../components/LoadIcon'
import ChatSection from '../../components/ChatSection.js'
import SideAgenda from '../../components/SideAgenda.js'
import { muteMusic, unmuteMusic } from '../../ducks/layout'
import openTheatre from '../../images/mobile/open-theatre.png'
import closeTheatre from '../../images/mobile/close-theatre.png'
import screen from '../../images/mobile/screen.png'
import { ChatKfairDb } from '../../firebaseConfig'
import config from '../../config'
import { COLORS } from '../../styles/theme'
import FacultySide from '../../components/FacultySide'
import speakerIcon from '../../images/event/speaker.png'
import CongressModal from '../../components/CongressModal'
import CommitteeModal from '../../components/CommitteeModal'

const MobileAuditorium = ({ currentUser, liveUrl }) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)
  const [sidebar, setSidebar] = useState(false)
  const [theatre, setTheatre] = useState(false)
  const [facultySide, setFacultySide] = useState(false)
  const [congressModal, setCongressModal] = useState(false)
  const [committeeModal, setCommitteeModal] = useState(false)

  useEffect(() => {
    Amplitude.visit('Auditorium')
  }, [currentUser.id])

  useEffect(() => {
    dispatch(muteMusic())

    return () => {
      if (localStorage.getItem('muted') === 'false') {
        dispatch(unmuteMusic())
      }
    }
  }, [dispatch])

  const toggleSidebar = () => {
    Amplitude.clickCheckIn()
    setSidebar(!sidebar)
  }

  const videoContainerTheatreStyle = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'black',
    zIndex: '99',
  }

  const toggleFacultySide = () => {
    if (facultySide === false) {
      Amplitude.clickFaculty()
    }
    setFacultySide(!facultySide)
  }

  const toggleCongress = () => {
    if (congressModal === false) {
      Amplitude.clickCongress()
    }
    setCongressModal(!congressModal)
  }

  const toggleCommittee =() => {
    if (committeeModal === false) {
      Amplitude.clickCommittee()
    }
    setCommitteeModal(!committeeModal)
  }

  return (
    <Page>
      <SideAgenda open={sidebar} toggleSidebar={toggleSidebar} hallNumber={1} currentUser={currentUser} />
      <FacultySide open={facultySide} toggleSidebar={toggleFacultySide} />
      <CongressModal showCongress={congressModal} setShowCongress={toggleCongress} />
      <CommitteeModal showCommittee={committeeModal} setShowCommittee={toggleCommittee} />
      <div className="outer-wrapper">
        <div className="container">
          <div className="checkin-container">
            <button className="checkin-icon" onClick={toggleSidebar}>
              <small>Programme</small>
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M0,0H24V24H0Z" fill="none" />
                <path
                  d="M19,3H14.82A2.988,2.988,0,0,0,9.18,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3ZM9.29,16.29,6.7,13.7a1,1,0,0,1,1.41-1.41L10,14.17l5.88-5.88A1,1,0,1,1,17.29,9.7L10.7,16.29a1,1,0,0,1-1.41,0Z"
                  fill={COLORS.hotButtonText}
                />
              </svg>
            </button>
            <button type="button" className="checkin-icon" onClick={toggleFacultySide}>
              <small>Faculty</small>
              <img src={speakerIcon} className="speaker ml-2" width="20" alt="icon"/>
            </button>
          </div>
          <div className="speaker-container">
            <button className="speaker-icon" onClick={toggleCongress}>
              <small>President of Congress</small>
            </button>
            <button type="button" className="speaker-icon" onClick={toggleCommittee}>
              <small>Organising Committee and International Advisory Board</small>
            </button>
          </div>

          <div className="screen-container">
            <img src={screen} className="screen" alt="screen" />
            <div className="video-container" style={theatre ? videoContainerTheatreStyle : {}}>
              {isLoading && <LoadIcon />}
              <iframe
                title="Live Broadcast"
                src={liveUrl}
                allow="autoplay; fullscreen"
                allowFullScreen
                frameBorder="0"
                onLoad={() => {
                  setIsLoading(false)
                }}
              />
            </div>
          </div>

          <button type="button" className="theatre-button" onClick={() => setTheatre(true)}>
            <img src={openTheatre} className="theatre-button-icon" alt="theatre-icon" />
            <p className="theatre-button-label">Theatre mode</p>
          </button>
        </div>

        <div className="chat-container">
          <ChatSection currentUser={currentUser} firebaseDb={ChatKfairDb} hallName="MainAuditorium" />
        </div>

        {theatre && (
          <div className="theatre-close">
            <img src={closeTheatre} onClick={() => setTheatre(false)} className="theatre-close-icon" alt="close-icon" />
          </div>
        )}
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: url(${config.assets.auditorium1.portrait});
  background-size: cover;
  background-position: 50% 50%;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  border-radius: 0px 0px 25px 25px;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 95%;
    margin: auto;
  }

  .checkin-icon {
    background: #002060;
    border-radius: 48px;
    display: flex;
    border: 1px solid white;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: ${COLORS.hotButtonText};
    padding: 8px 16px;
    width: 45%;
    small {
      font-weight: 800;
    }
  }
  .checkin-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0px 20px 0px;
  }
  .checkin {
    width: 38%;
    height: auto;
  }

  .speaker-container {
    width: 100%;
    align-items: center;
    margin: 20px 0px 20px 0px;
  }

  .speaker-icon {
    background: #002060;
    border-radius: 48px;
    display: flex;
    border: 1px solid white;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: ${COLORS.hotButtonText};
    padding: 8px 16px;
    width: 100%;
    margin: 20px auto;
    small {
      font-weight: 800;
    }
  }


  .screen-container {
    width: 100%;
    height: 0;
    padding-bottom: 58.5%;
    position: relative;
  }

  .screen {
    width: 100%;
    position: absolute;
  }

  .video-container {
    width: 92%;
    height: 81%;
    background: #1e1e1e;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50.5%, -51%);

    iframe {
      height: 100%;
      width: 100%;
    }
  }

  .title {
    width: 100%;
    margin: 20px 0px;
  }

  .chat-container {
    width: 100%;
    height: 500px;
    margin-top: 36px;
  }

  .theatre-button {
    width: 140px;
    height: 30px;
    background: black;
    margin: 10px 10px 0px 0px;
    float: right;
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    opacity: 0.6;
    padding: 0;
  }

  .theatre-button-label {
    color: white;
    font-size: 12px;
    margin: 0px 10px 0px 0px;
  }

  .theatre-button-icon {
    width: 20px;
    margin: 0px 10px;
  }

  .theatre-close {
    color: white;
    background: black;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 99;
    opacity: 0.6;
  }

  .theatre-close-icon {
    width: 20px;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileAuditorium
